import React from 'react';
import '../styles/word-flipper.css';

export default function WordFlipper() {

    return (
        <div className="word-flipper">
            <span></span>
            <span>develop</span>
            <span>make</span>
            <span>create</span>
            <span>design</span>
        </div>
    );
}